import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import InfoButton from './info-button';
import messages from './messages';

const PRIVACY_LEARN_MORE_LINK = 'https://www.atlassian.com/legal/privacy-policy';

export const ProjectDepartmentTypeFreeTextLabel = () => {
	const { formatMessage } = useIntl();

	return (
		<LabelWrapper>
			{formatMessage(messages.teamType)}
			<ToolTipWrapper>
				<InfoButton
					ariaLabelText={formatMessage(messages.learnMoreAriaLabelText)}
					message={formatMessage(messages.tooltip)}
					action={{
						name: formatMessage(messages.learnMore),
						href: PRIVACY_LEARN_MORE_LINK,
					}}
				/>
			</ToolTipWrapper>
		</LabelWrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ToolTipWrapper = styled.div({
	fontSize: token('space.150', '12px'),
	fontWeight: 400,
	marginLeft: token('space.025', '2px'),
	marginRight: token('space.negative.025', '-2px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LabelWrapper = styled.div({
	display: 'flex',
});
